// extracted by mini-css-extract-plugin
export default {"cardCtaLink":"_eRSnH"};